"use client";

import Image from "next/image";
import { useMessages } from "@/lib/i18n/client";
import messages from "./movie-data-attribution.i18n";

// Logos oficiales descargados a public/attribution/ (no hotlink): TMDB desde
// themoviedb.org/about/logos-attribution, JustWatch desde justwatch.com.
// TMDB exige que su logo sea menos prominente que la marca propia — por eso
// van chicos y al pie. width/height = tamaño intrínseco (solo para el ratio).
// De cliente por el idioma (solo se usa dentro de componentes de cliente).
export function MovieDataAttribution() {
  const t = useMessages(messages);
  return (
    <span className="inline-flex flex-wrap items-center gap-x-2 gap-y-1">
      {t.providedBy}
      <Image src="/attribution/tmdb.svg" alt="TMDB" width={273} height={36} unoptimized className="h-2.5 w-auto" />
      {t.and}
      <Image src="/attribution/justwatch.png" alt="JustWatch" width={505} height={76} unoptimized className="h-3 w-auto" />
    </span>
  );
}
